import { render, staticRenderFns } from "./pedidosAdd.vue?vue&type=template&id=1ba1b361&"
import script from "./pedidosAdd.vue?vue&type=script&lang=js&"
export * from "./pedidosAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports